<div #container *ngIf="showSessionId && _refId">
    <akit-interaction
      *ngIf="showSessionId"
      [attr.session-id]="showSessionId"
      [attr.ref-id]="_refId"
      [attr.review-mode]="reviewMode ? 'true' : 'false'"
      [attr.solution-mode]="solutionMode ? 'true' : 'false'"
    >
    </akit-interaction>
</div>
